import type { MessageKey } from 'types/LocaleMessageKey';

import type { AccessoryCardProps } from '@/app/components/AccessoryCard';
import getSrcUrl from '@/app/components/Image/utils/getSrcUrl';
import type { SupportedCurrency } from '@/app/types/currency';

interface AccessoryData
  extends Pick<
    AccessoryCardProps,
    | 'dataCy'
    | 'title'
    | 'caption'
    | 'href'
    | 'imageSrc'
    | 'priceText'
    | 'showDecimalsForWholeDollars'
  > {
  readonly productKey: string;
  readonly priceData?: {
    readonly basePrice: number;
    readonly currencyCode: SupportedCurrency;
  };
}

export const NOMAD_ACCESSORY: AccessoryData = {
  dataCy: 'accessory-or4-charging-case',
  productKey: 'OuraRing4ChargerCase',
  title: 'nomad_product_title' as MessageKey,
  caption: 'store_accessories_or4_charging_case_caption' as MessageKey,
  href: '/store/accessories/oura-ring-4-charging-case',
  imageSrc: getSrcUrl(
    'product/or4-charging-case.png?fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1',
  ),
  showDecimalsForWholeDollars: true,
};

const accessoriesData: AccessoryData[] = [
  {
    dataCy: 'accessory-dexcom-cgm',
    productKey: 'SteloDexcomCGM',
    title: 'stelo_dexcom_cgm_title' as MessageKey,
    caption: 'store_accessories_dexcom_caption' as MessageKey,
    href: '/store/dexcom/stelo-glucose-biosensor',
    imageSrc: getSrcUrl(
      'product/dexcom-stelo.png?fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=2',
    ),
    showDecimalsForWholeDollars: true,
  },
  {
    dataCy: 'accessory-or4-charger',
    productKey: 'OuraRing4Charger',
    title: 'charger_set_gen_4_title' as MessageKey,
    caption: 'store_accessories_or4_charger_caption' as MessageKey,
    href: '/store/accessories/charger-oura-4/select-size',
    imageSrc: getSrcUrl(
      'product/or4-charger.png?fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1.1',
    ),
    showDecimalsForWholeDollars: true,
  },
  {
    dataCy: 'accessory-gen3-charger',
    productKey: 'ChargerSet3x',
    title: 'charger_set_gen_3_title' as MessageKey,
    caption: 'store_accessories_gen3_charger_caption' as MessageKey,
    href: '/store/accessories/charger-oura-3/select-size',
    imageSrc: getSrcUrl(
      'product/charger_set_gen3_2.png?fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1.',
    ),
    showDecimalsForWholeDollars: true,
  },
  {
    dataCy: 'accessory-gift-card',
    productKey: 'OuraGiftCard',
    title: 'store_accessories_gift_cards_title' as MessageKey,
    caption: 'store_accessories_gift_cards_caption' as MessageKey,
    href: '/store/gift-card',
    imageSrc: getSrcUrl('product/gift_card.png'),
    priceText: 'store_from_price' as MessageKey,
    showDecimalsForWholeDollars: false,
    // hardcoded price data since gift card is not part of the product catalogue
    priceData: {
      basePrice: 25,
      currencyCode: 'USD' as SupportedCurrency,
    },
  },
];

export default accessoriesData;
